import { render } from "./DragonTigerTable.vue?vue&type=template&id=199f5294&ts=true"
import script from "./DragonTigerTable.vue?vue&type=script&lang=ts"
export * from "./DragonTigerTable.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__